const PROCESSES_FOLLOWER_EXTENSIONS = '.fpid';
const PROCESSES_ACTIVE_PROCESS_FILENAME = 'active.apid';
const PROCESSES_DIRECTORY_PATH = '/run';

export {
  PROCESSES_ACTIVE_PROCESS_FILENAME,
  PROCESSES_DIRECTORY_PATH,
  PROCESSES_FOLLOWER_EXTENSIONS
};
